<script>
    export let name = "some-radio-button-name",
        value = "",
        checked = false;
</script>

<div class="checkbox-icon">
    <input type="radio" {name} {value} checked={checked} />
    <i class="material-icons unchecked">lens</i>
    <i class="material-icons checked">check_circle</i>
</div>

<style>
    /* checkbox (Laura's checkbox code from /premium/enrollment experiment. */

    .checkbox-icon {
        height: 20px;
        width: 20px;
        margin-right: 24px;
        position: relative;
        background-color: transparent;
        border-radius: 50%;
    }

    .checkbox-icon i.unchecked {
        height: auto;
        width: auto;
    }
    .checkbox-icon input {
        opacity: 0; /* hide but function */
        position: absolute;
        top: -2px;
        cursor: pointer;
    }

    .checkbox-icon i.material-icons {
        position: absolute;
        pointer-events: none;
    }

    .checkbox-icon i.checked {
        color: #0055b7;
        border: 1px solid #0055b7;
        border-radius: 50%;
    }

    .checkbox-icon i.unchecked {
        color: transparent;
        border: 1px solid #666;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .checkbox-icon input:checked ~ i.checked,
    .checkbox-icon input:not(:checked) ~ i.checked {
        opacity: 1; /* show */
    }

    .checkbox-icon input:checked ~ i.unchecked,
    .checkbox-icon input:not(:checked) ~ i.checked {
        opacity: 0; /* hide */
    }
</style>
